<!--  -->
<template>
    <div id='approveApplyInfo'>
        <section>
            <h5>
                <div class="title">申请信息</div>
            </h5>
            <div class="infoWrapper">
                <div>
                    <label>申请类型</label>
                    <span>{{xcx.checkType}}</span>
                </div>
                <div>
                    <label>投放渠道</label>
                    <span>{{xcx.channel}}</span>
                </div>
                <div>
                    <label>适用人群</label>
                    <span>{{xcx.userType}}</span>
                </div>
                <div>
                    <label>激活码类型</label>
                    <span>{{xcx.type}}</span>
                </div>
                <div>
                    <label>活动价（元）</label>
                    <span>{{xcx.total}}</span>
                </div>
                <div>
                    <label>原价（元）</label>
                    <span>{{xcx.sellingPrice}}</span>
                </div>
                <div>
                    <label>折扣</label>
                    <span>{{xcx.discount}}折</span>
                </div>
                <div>
                    <label>激活明细</label>
                    <div class="detailTable">
                        <div class="thead">
                            <span>编码</span>
                            <span>名称</span>
                            <span>标准/（元）</span>
                            <span>数量</span>
                        </div>
                        <div class="tbody" v-for="(v,k) in xcx.skuDetails" :key="k">
                            <span><i>{{v&&v[0].sku}}</i></span>
                            <div class="box">
                                <div v-for="(item,index) in v" :key="index">
                                    <span><i>{{item.name}}</i></span>
                                    <span><i>{{item.parAmt}}</i></span>
                                    <span><i>{{item.num}}</i></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <label>发放数量</label>
                    <span>{{xcx.quantity}}</span>
                </div>
                <div>
                    <label>开始时间</label>
                    <span>{{xcx.startTime}}</span>
                </div>
                <div>
                    <label>过期时间</label>
                    <span>{{xcx.expireTime}}</span>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    props: {
        detail: {
            type: Object,
            default: () => { return {} }
        }
    },
    components: {},

    computed: {

    },
    watch: {
        detail: {
            handler(nv, ov) {
                if (nv) {
                    this.xcx = nv.xcxInfo
                }
            },
            deep: true,
        }
    },
    data() {
        return {
            xcx: ''
        };
    },

    mounted() { },

    methods: {}
}

</script>
<style lang='less' scoped>
#approveApplyInfo {
    padding: 20px;
    section {
        padding: 20px;
        background: #ffffff;
        border-radius: 20px;
        h5 {
            padding: 20px 0;
            border-bottom: 1px solid #ccc;
            margin: 0 0 20px 0;
        }
        .infoWrapper {
            > div {
                padding: 10px 0;
                > label {
                }
                label,
                span {
                    display: inline-block;
                }
                label {
                    width: 180px;
                    color: #999999;
                }
            }
        }
        .title {
            padding-left: 20px;
            border-left: 10px solid #0c92f4;
        }
    }
    .detailTable {
        width: 100%;
        padding-top: 10px;
        > div {
            width: 100%;
            display: flex;
            justify-content: space-between;
            > span {
                flex-basis: 25%;
                text-align: center;
                border: 1px solid #999999;
                word-break: break-all;
            }
        }
        .thead {
            background: #f2f2f2;
            > span {
                padding: 5px 0;
                &:not(:last-child) {
                    border-right: 0;
                }
            }
        }
        .tbody {
            > span {
                border-top: 0;
                display: flex;
                i {
                    flex: 1;
                    align-self: center;
                    text-align: center;
                    font-style: normal;
                }
            }
            .box {
                width: 75%;
                > div {
                    display: flex;
                    justify-content: space-between;
                    > span {
                        flex: 1;
                        border: 1px solid #999999;
                        border-left: 0;
                        border-top: 0;
                        padding: 10px 0;
                        display: flex;
                        width: 33.33%;
                        i {
                            flex: 1;
                            align-self: center;
                            text-align: center;
                            font-style: normal;
                            font-size: 24px;
                            display: block;
                            width: 100%;
                            word-break: break-all;
                        }
                    }
                }
            }
        }
    }
}
</style>